/* Gleva · gvb-hero-film.js — homepage brand film (sections/gvb-hero-film.liquid).
   The <video> autoplays from the HTML on its own (muted, inline, looping; the files stream from the first byte).
   This script only:
   - fades the film in over the poster once it is actually playing;
   - starts it on the first touch, scroll or key if the browser refused autoplay (e.g. phone low-power mode);
   - pauses it while it is off screen or the tab is hidden, and resumes when it is back (no visible control:
     founder, 21 Oct 2026, "film should autoplay no pause");
   - keeps the still frame for reduced-motion and Save-Data visitors;
   - falls back to the full Shopify rendition if the 720p one is missing. */
import { G } from 'gvb';

const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
const conn = navigator.connection || {};
const saveData = !!conn.saveData || (window.matchMedia && matchMedia('(prefers-reduced-data: reduce)').matches);

function boot(band) {
  if (band._gvbHF) return;
  const v = band.querySelector('video');
  if (!v) return;
  band._gvbHF = true;
  v.muted = true; v.defaultMuted = true; v.playsInline = true;

  if (G.reduce || saveData) {   /* still frame only: stop the download too */
    v.removeAttribute('autoplay'); v.pause();
    $$('source', v).forEach((s) => s.removeAttribute('src'));
    v.load();
    return;
  }

  let inView = true;
  const show = () => band.classList.add('has-film');
  if (!v.paused && v.readyState > 2) show();
  v.addEventListener('playing', show, { once: true });

  const play = () => { if (inView && !document.hidden) { const p = v.play(); if (p && p.catch) p.catch(() => {}); } };
  const kick = () => { play(); ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach((t) => window.removeEventListener(t, kick)); };
  ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach((t) => window.addEventListener(t, kick, { passive: true }));
  play();

  $$('source[data-fallback]', v).forEach((s) => s.addEventListener('error', () => {
    if (s.getAttribute('src') === s.dataset.fallback) return;
    s.setAttribute('src', s.dataset.fallback); v.load(); play();
  }));

  if ('IntersectionObserver' in window) {
    new IntersectionObserver((es) => {
      inView = es[0].isIntersecting;
      if (inView) play(); else v.pause();
    }).observe(band);
  }
  document.addEventListener('visibilitychange', () => { if (document.hidden) v.pause(); else play(); });
}

const init = (scope) => $$('[data-hfilm]', scope).forEach(boot);
init(document);
document.addEventListener('shopify:section:load', (e) => init(e.target));
